export class EffectRandom {
  private state: number;

  constructor(seed = 0x9e3779b9) {
    /** Zero is a fixed point of xorshift32 — seeding with 0 would give a constant stream. */
    this.state = seed >>> 0 || 0x9e3779b9;
  }

  next(): number {
    let x = this.state;
    x ^= x << 13;
    x ^= x >>> 17;
    x ^= x << 5;
    this.state = x >>> 0;
    return this.state / 0x1_0000_0000;
  }

  range(min: number, max: number): number {
    return this.next() * (max - min) + min;
  }

  int(min: number, max: number): number {
    return Math.floor(this.next() * (max - min + 1)) + min;
  }
}
